import { render, staticRenderFns } from "./ResourceBlock.vue?vue&type=template&id=85747062&scoped=true&"
import script from "./ResourceBlock.vue?vue&type=script&lang=js&"
export * from "./ResourceBlock.vue?vue&type=script&lang=js&"
import style0 from "./ResourceBlock.vue?vue&type=style&index=0&id=85747062&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85747062",
  null
  
)

export default component.exports